import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  })
});

class OSSPod extends React.Component {
  static Title = ({ children, classes, bottomBorder, inlineStyles = {} }) => {
    const styles = bottomBorder
      ? Object.assign({ borderBottom: "1px solid #eeeeee" }, inlineStyles)
      : Object.assign({}, inlineStyles);

    return (
      <Paper className={classes.root} style={styles} elevation={0} square>
        {children}
      </Paper>
    );
  };

  static Body = ({ elevation, children, classes, inlineStyles = {} }) => {
    const styles = Object.assign({}, inlineStyles);
    return (
      <Paper
        className={classes.root}
        elevation={elevation}
        square
        style={styles}>
        {children}
      </Paper>
    );
  };

  static Footer = ({ children, classes, topBorder, inlineStyles = {} }) => {
    const styles = topBorder
      ? Object.assign({ borderTop: "1px solid #eeeeee" }, inlineStyles)
      : Object.assign({}, inlineStyles);
    return (
      <Paper className={classes.root} elevation={0} square style={styles}>
        {children}
      </Paper>
    );
  };

  render() {
    const { classes } = this.props;

    return React.Children.map(this.props.children, child =>
      React.cloneElement(child, { classes })
    );
  }
}

OSSPod.propTypes = {
  children: PropTypes.node,
  elevation: PropTypes.number
};
OSSPod.defaultProps = {
  children: ""
};
OSSPod.Body.defaultProps = {
  children: "",
  elevation: 0
};
OSSPod.Title.propTypes = {
  backgroundColor: PropTypes.string,
  bottomBorder: PropTypes.bool
};
OSSPod.Title.defaultProps = {
  backgroundColor: "#fff",
  bottomBorder: true
};
OSSPod.Footer.propTypes = {
  backgroundColor: PropTypes.string,
  topBorder: PropTypes.bool
};
OSSPod.Footer.defaultProps = {
  backgroundColor: "#fff",
  topBorder: true
};

export default withStyles(styles)(OSSPod);
